import {
  CheckCircle,
  LockReset,
  Mail,
  Pending,
  Warning,
  Delete,
  Add,
} from '@mui/icons-material';
import {
  Box,
  Button,
  Chip,
  Container,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import TabHeaderTypography from '../tab_header';

const ManageUsers = ({ users }) => {
  const getStatusChip = (status) => {
    const formattedStatus =
      status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    switch (status.toUpperCase()) {
      case 'CONFIRMED':
        return (
          <Chip
            icon={<CheckCircle />}
            label={formattedStatus}
            color="success"
            size="small"
          />
        );
      case 'UNCONFIRMED':
        return (
          <Chip
            icon={<Pending />}
            label={formattedStatus}
            color="warning"
            size="small"
          />
        );
      case 'ARCHIVED':
      case 'UNKNOWN':
        return (
          <Chip
            icon={<Warning />}
            label={formattedStatus}
            color="error"
            size="small"
          />
        );
      default:
        return <Chip label={formattedStatus} size="small" />;
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <TabHeaderTypography title="Manage" highlight="Users" />
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => {
            //setCurrentPackage(null);
            //setOpenForm(true);
          }}
        >
          Add User
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Companies</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id}>
                <TableCell>{user.name}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>{user.groups?.[0]?.name || 'User'}</TableCell>
                <TableCell>{user.companies}</TableCell>
                <TableCell>{getStatusChip(user.status)}</TableCell>
                <TableCell>
                  <Tooltip title="Email user">
                    <IconButton color="primary" disabled>
                      <Mail />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Reset Password">
                    <IconButton color="primary" disabled>
                      <LockReset />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete user">
                    <IconButton color="error" disabled>
                      <Delete />
                    </IconButton>
                  </Tooltip>
                  {/* <Button
                  size="small"
                  variant="outlined"
                  startIcon={<LockReset />}
                  sx={{ ml: 1 }}
                >
                  Reset Password
                </Button> */}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default ManageUsers;
